__turbopack_context__.v({
  "editorShell": "FolderNotes-module__jN3odq__editorShell",
  "editorShellDisabled": "FolderNotes-module__jN3odq__editorShellDisabled",
  "headerRow": "FolderNotes-module__jN3odq__headerRow",
  "inputArea": "FolderNotes-module__jN3odq__inputArea",
  "labelRow": "FolderNotes-module__jN3odq__labelRow",
  "previewBox": "FolderNotes-module__jN3odq__previewBox",
  "previewBoxDisabled": "FolderNotes-module__jN3odq__previewBoxDisabled",
  "previewContent": "FolderNotes-module__jN3odq__previewContent",
  "previewDivider": "FolderNotes-module__jN3odq__previewDivider",
  "regenerateAlertActions": "FolderNotes-module__jN3odq__regenerateAlertActions",
  "regenerateAlertOverlay": "FolderNotes-module__jN3odq__regenerateAlertOverlay",
  "root": "FolderNotes-module__jN3odq__root",
  "statusAndModeControls": "FolderNotes-module__jN3odq__statusAndModeControls",
  "textInputWrapper": "FolderNotes-module__jN3odq__textInputWrapper",
  "toolbarWrapperPinned": "FolderNotes-module__jN3odq__toolbarWrapperPinned",
});
